export default {"src":"/_next/static/media/chevron-down-black-carousel.c2b72168.svg","height":20,"width":11,"blurWidth":0,"blurHeight":0};